// Sep 2026 - "Copy Order" pre-fill payload, carried via router state from OrderDetailsDrawer to
// CreateOrder. Deliberately just basic patient/provider demographic fields - never SampleId,
// Kit_id/NuviaOrderId, testCode/testName, or any pricing/payment field, all of which need to be
// chosen or computed fresh for the new order rather than copied from the old one.
export type CopyOrderPrefill = Partial<Pick<OrderFormState,
    | 'patientFirstName' | 'patientMiddleName' | 'patientLastName' | 'dateOfBirth' | 'sex'
    | 'patientPhone' | 'patientEmail' | 'patientStreet1' | 'patientStreet2' | 'patientCity'
    | 'patientState' | 'patientZipcode' | 'patientCounty'
    | 'providerType' | 'providerFirstName' | 'providerLastName' | 'providerPhone' | 'providerFax' | 'providerNpi'
>>;

export type OrderFormState = {
    testName?: string | null;
    testCode?: string | null;
    testPanel?: string | null;
    internalComment?: string | null;
    needsContact?: string | null;
    patientFirstName?: string | null;
    patientMiddleName?: string | null;
    patientLastName?: string | null;
    dateOfBirth?: string | null;
    sex?: string | null;
    patientPhone?: string | null;
    patientEmail?: string | null;
    patientStreet1?: string | null;
    patientStreet2?: string | null;
    patientCity?: string | null;
    patientState?: string | null;
    patientZipcode?: string | null;
    patientCounty?: string | null;
    providerName?: string | null;
    providerFirstName?: string | null;
    providerLastName?: string | null;
    providerType?: string | null;
    providerNpi?: string | null;
    providerPhone?: string | null;
    providerFax?: string | null;
    orgId?: string | null;
    organizationName?: string | null;
    organizationType?: string | null;
    organizationNumber?: string | null;
    active?: boolean | null;
    organizationStreet1?: string | null;
    organizationStreet2?: string | null;
    organizationCity?: string | null;
    organizationZipcode?: string | null;
    organizationState?: string | null;
    organizationPhone?: string | null;
    organizationFax?: string | null;

    updateComment?: string | null;

    sampleId?: string | null;
    specimenSource?: string | null;
    collectionDatetime?: string | null;

    sampleId2?: string | null;
    specimenSource2?: string | null;
    collectionDatetime2?: string | null;

    sampleId3?: string | null;
    specimenSource3?: string | null;
    collectionDatetime3?: string | null;

    sampleId4?: string | null;
    specimenSource4?: string | null;
    collectionDatetime4?: string | null;

    sampleId5?: string | null;
    specimenSource5?: string | null;
    collectionDatetime5?: string | null;
    orderDatetime?: string | null;
    kitId?: string | null;
    testLocation?: string | null;
    orderClinician?: string | null;
    // Pre-Buy Phase 4 (Flow 3 - Clinic Submission) only - set client-side after the submission fee
    // is charged (see clinicSubmission feature's chargeSubmissionFee - Aug 2026, generalized from
    // a flat $45 "HPV lab fee"), then posted through unchanged via the regular createOrder action -
    // POST /api/orders binds the full Order entity directly, so these just ride along with
    // everything else rather than needing their own endpoint. Field names kept as-is (still
    // "hpvLabFee*") to avoid touching the legacy Order entity/grids that already display them.
    hpvLabFeeAmount?: number | null;
    hpvLabFeeStripePaymentIntentId?: string | null;
    // Aug 2026 - how much of hpvLabFeeAmount was covered by the org's Test Credit $ balance -
    // set alongside the other two, same reasoning.
    hpvLabFeeCreditApplied?: number | null;
    // Sep 2026 - true when this order was submitted via the "Consignment Kit" dropdown option
    // (a physical kit the clinic already had on hand, never tracked through Pre-Buy) - synced
    // client-side from OrderForm's manualKitEntry state, same "ride along through POST /api/orders'
    // full-entity binding" pattern as the hpvLabFee* fields above. Needed as a real purchase-method
    // category for the Revenue/Cash executive report.
    isConsignment?: boolean | null;
}

export enum OrderStatus {
    OPEN = 'Open',
}
